<div class="component-block" [id]="componentId">
  <h1>{{name}}</h1>
  <h4>{{description}}</h4>

  <ng-content select="[component]"></ng-content>

  <ng-container *ngIf="showExpanding">
    <button class="expand" (click)="isExpanded = !isExpanded">
      {{ isExpanded ? 'Close' : 'Open' }}
    </button>
  </ng-container>

  <ng-container *ngIf="isExpanded">
    <ng-content select="[inputs-block]"></ng-content>
  </ng-container>

  <ng-content select="[button-after-inputs]"></ng-content>
</div>
